<template>
    <div class="crm-payments">
        <b-card class="payments-card">
            <b-table
                :items="payments"
                :fields="tableFields"
                responsive
                hover
                class="payments-table"
                tbody-tr-class="payment-row"
            >
                <template #cell(paymentId)="data">
                    <span class="payment-id">{{ data.item.paymentId }}</span>
                </template>
                <template #cell(date)="data">
                    <span class="payment-date">{{ data.item.date }}</span>
                </template>
                <template #cell(method)="data">
                    <span class="payment-method">
                        <i class="fa fa-credit-card method-icon"></i>
                        {{ data.item.method }}
                    </span>
                </template>
                <template #cell(reference)="data">
                    <b-button variant="link" class="link-reference p-0" @click="viewReference(data.item)">
                        {{ data.item.reference }}
                    </b-button>
                </template>
                <template #cell(amount)="data">
                    <span class="payment-amount">${{ formatAmount(data.item.amount) }}</span>
                </template>
                <template #cell(status)="data">
                    <b-badge pill class="badge-successful">{{ data.item.status }}</b-badge>
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "CrmPayments",
    props: {
        accountId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            tableFields: [
                { key: "paymentId", label: "PAYMENT ID", thClass: "table-header" },
                { key: "date", label: "DATE", thClass: "table-header" },
                { key: "method", label: "METHOD", thClass: "table-header" },
                { key: "reference", label: "REFERENCE", thClass: "table-header" },
                { key: "amount", label: "AMOUNT", thClass: "table-header amount-col" },
                { key: "status", label: "STATUS", thClass: "table-header status-col" },
            ],
            payments: [
                { paymentId: "PAY-8821", date: "2026-02-02", method: "Card (Visa)", reference: "tx_98273645", amount: 1200, status: "Successful" },
                { paymentId: "PAY-7732", date: "2026-01-02", method: "Card (Visa)", reference: "tx_88273645", amount: 1200, status: "Successful" },
            ],
        };
    },
    methods: {
        formatAmount(amount) {
            if (amount >= 1000) {
                return `${Math.floor(amount / 1000)},${String(amount % 1000).padStart(3, "0")}`;
            }
            return String(amount);
        },
        viewReference(payment) {
            console.log("viewReference", payment);
        },
    },
};
</script>

<style scoped>
.crm-payments {
    padding: 0;
}

.payments-card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: 24px;
}

.payments-card >>> .card-body {
    padding: 0;
}

.payments-table >>> thead th {
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    color: #6c757d;
    text-transform: uppercase;
    border-bottom: 1px solid #e9ecef;
    padding: 14px 16px;
}

.payments-table >>> thead th.amount-col,
.payments-table >>> thead th.status-col {
    text-align: right;
}

.payments-table >>> tbody td {
    padding: 16px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f3f5;
}

.payments-table >>> tbody tr.payment-row:hover {
    background-color: #f8f9fa;
}

.payments-table >>> tbody tr:last-child td {
    border-bottom: 0;
}

.payment-id {
    font-weight: 700;
    color: #1a1d21;
}

.payment-date {
    color: #495057;
}

.payment-method {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #1a1d21;
}

.method-icon {
    color: #6c757d;
}

.link-reference {
    font-weight: 500;
    color: #1565c0;
    font-size: 0.9rem;
}

.link-reference:hover {
    color: #0d47a1;
    text-decoration: underline;
}

.payment-amount {
    font-weight: 700;
    color: #1a1d21;
}

.payments-table >>> tbody td:last-child,
.payments-table >>> tbody td:nth-child(5) {
    text-align: right;
}

.badge-successful {
    background-color: #d4edda !important;
    color: #155724 !important;
    font-weight: 500;
    padding: 6px 12px;
}
</style>
